import type { StructuralDecorator } from "../decorator.js";
import type { CommentRequired, Rule } from "../rules.js";
import type { AnswersOf, ItemKeyOf, ModulesOf, TypedBy } from "../typedBy.js";

/**
 * When an item's comment must be given once it is asked and answered:
 * always, or as a rule says, over answers typed by the modules it is typed
 * by. The form is refused where the item takes no comment.
 */
export const commentRequiredWhen = <Typing extends TypedBy>(
  _typedBy: Typing,
  item: ItemKeyOf<ModulesOf<Typing>>,
  when: Rule<AnswersOf<ModulesOf<Typing>>> | "always",
): StructuralDecorator => ({
  kind: "structural",
  item: (view) =>
    view.at.item === item
      ? {
          ...view,
          // As for `showWhen`: every answer handed over is one the stored
          // schema accepted, so it is never outside its key's response type.
          commentRequired: when as CommentRequired,
        }
      : view,
});
